/**
 * Checks if a string is filled (not empty and not just whitespace).
 */
export function isFilled(value?: string | null): boolean {
  if (!value) {
    return false;
  }

  return value.trim().length > 0;
}
